import {defineStore} from "pinia";
export const empresaStore = defineStore("empresaStore", {
    state: () =>
        ({
            loading: false as boolean,
            pagination: {
                per_page: 0,
                current_page: 1,
                last_page: 0,
            },
            empresas: [],
            empresasListado: [],
            showDialogSancion: false as boolean,
            empresa: [],
            tipoMaterial: []
        }),
});